<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">{{ category.name }}</h1>
            </div>
        </div>

        <div class="container mt-4">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: category.name, href: `/categories/${category.slug}`, data: breadcrumbQueryParams}
            ]" class="mb-4"/>

            <div class="row">
                <div class="text-sm mb-6 md:mb-0 md:col-1/3 lg:col-1/4">

                    <div class="md:hidden">
                        <label class="block mb-2">Choose Sub-Category</label>
                        <SelectBox v-model="subCategory" :options="subCategories" class="mb-6"/>
                    </div>

                    <!--<ul class="hidden leading-tight md:block">-->
                    <!--    <li v-for="child in subCategories"-->
                    <!--        class="py-4 border-b border-dotted border-grey-dark last:border-0 last:pb-0">-->
                    <!--        <button-->
                    <!--            :class="{'font-semibold': subCategory === child.value}"-->
                    <!--            class="flex justify-start items-start w-full p-1 text-left"-->
                    <!--            @click.prevent="subCategory = child.value">-->
                    <!--            <font-awesome-icon class="text-primary mr-4" icon="chevron-right"/>-->
                    <!--            <span class="flex-1">{{ child.label }}</span>-->
                    <!--        </button>-->
                    <!--    </li>-->
                    <!--</ul>-->
                    <ul class="leading-tight">
                         <li v-for="parent in categories" :key="parent.id" class="py-4 border-b border-dotted border-grey-dark last:border-0 last:pb-0">
                            <button
                                class="flex justify-start items-start w-full p-1 text-left no-underline"
                                :class="{'font-semibold': category.id == parent.id }"
                            >
                                <font-awesome-icon class="text-primary mr-4" :icon="openCategories.includes(parent.id) ? 'chevron-down' : 'chevron-right'" @click="toggleCategory(parent.id)" />
                                <a class="anchor-color" :href="`/categories/${parent.slug}`"><span class="flex-1">{{ parent.name }}</span></a>
                            </button>
                    
                            <ul v-show="openCategories.includes(parent.id)" class="pl-4" style="padding-left:25px;">
                                <li v-for="child in parent.children" :key="child.id" class="py-4 border-b border-dotted border-grey-dark last:border-0 last:pb-0">
                                    <button
                                        :class="{'font-semibold': subCategory === child.id}"
                                        class="flex justify-start items-start w-full p-1 text-left"
                                        @click.prevent="subCategory = child.id">
                                        <font-awesome-icon class="text-primary mr-4" icon="chevron-right"/>
                                        <span class="flex-1">{{ `${child.name} (${child.posts_count})` }}</span>
                                    </button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div class="mt-6">
                        <div class="search-div relative block">
                            <label class="block mb-4 font-semibold">Search by keywords</label>
                            <input 
                                v-model="search"
                                clearable 
                                placeholder="Search keywords"
                                type="text"
                                class="block w-full border border-grey-light p-2 pr-12"
                                @keydown.enter="fetchTagsList('all')"
                            />
                            <button
                                v-show="search" 
                                aria-label="Perform Search"
                                class="absolute inset-y-0 right-0 mr-6 search-button text-grey px-2"
                                type="button"
                                @click.prevent="clearSearch">
                                <font-awesome-icon icon="times"/>
                            </button>
                            <button
                                aria-label="Perform Search"
                                class="absolute inset-y-0 right-0 search-button text-primary px-2"
                                @click.prevent="fetchTagsList('all')">
                                <font-awesome-icon icon="search"/>
                            </button>
                        </div>
                        <ul class="space-y-4 mt-4 small-scroll" :class="{'scroll-content': tagsKeywordList.length > 100}">
                            <li v-for="label in tagsKeywordList">
                                <label class="flex items-center relative cursor-pointer">
                                    <input
                                        :checked="label.status"
                                        class="absolute opacity-0"
                                        type="checkbox"
                                        @input="toggleStatus(label)"
                                    />
                                    <span class="flex justify-center items-center w-6 h-6 mr-3 border border-grey-light">
                                        <font-awesome-icon
                                            :class="{'opacity-0': !label.status}"
                                            class="text-primary"
                                            icon="check"
                                        />
                                    </span>
                                    <span class="leading-6">{{ label.name }}  {{ `(${label.posts_count})` }}</span>
                                </label>
                            </li>
                        </ul>
                        <div v-if="!tagsKeywordList.length">No keywords found</div>
                        <div v-if="tagsKeywordList.length && tagsKeywordList.length <= 100" class="show-more" @click="fetchTagsList('all')">Show more</div>
                        <div v-if="tagsKeywordList.length && tagsKeywordList.length > 100" class="show-more" @click="fetchTagsList('paginate')">Show Less</div>
                    </div>
                    <div class="mt-6">
                        <label class="block mb-4 font-semibold">Type</label>
                        <CheckboxList v-model="type" :options="postTypes"/>
                    </div>
                    <div class="mt-6">
                        <label class="block mb-4 font-semibold">Level</label>
                        <CheckboxList v-model="levels" :options="postLevels"/>
                    </div>
                </div>
                <div class="md:col-2/3 lg:col-3/4">
                    <template v-if="posts.data.length">
                        <div class="display-filter mb-6 items-center">
                            <div>
                                <label>Sort by</label>
                                <SelectBox
                                    v-model="sort"
                                    :options="sortOptions"
                                    class="inline-block relative w-full text-primary"
                                    label="Sort by"/>
                            </div>
                            <div>
                                <label>View</label>
                                <SelectBox
                                    v-model="view"
                                    :options="viewMode"
                                    class="inline-block relative w-full text-primary"
                                    label="View"/>
                            </div>
                        </div>

                        <PostsList :posts="posts.data" :view="view"/>
                    </template>

                    <p v-else class="text-sm bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3">
                        There are no posts for this category yet. Please select another category.
                    </p>
                </div>
            </div>
            <PaginationLinks
                v-if="posts.data.length"
                :meta="posts.meta"
                :per-page="view == 'list' ? 30 : 15"
                class="my-8"
                @change="setPage"/>
        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import PostsList from "@app/Shared/Components/PostsList";
import PaginationLinks from "@app/Shared/Components/PaginationLinks";
import SelectBox from "@app/Shared/Components/SelectBox";
import CheckboxList from "@app/Shared/Components/CheckboxList";

export default {

    mixins: [HasMetaData],

    props: {
        category: Object,
        posts: Object,
        categories: Array,
    },

    data() {
        return {
            postTypes: {
                Tutorial: 'Tutorial',
                CaseReport: 'Case Report',
            },
            postLevels: {
                fundamental: 'Fundamental',
                advanced: 'Advanced',
                innovative: 'Innovative',
            },
            sortOptions: [
                {label: 'Latest', value: '-published_at'},
                {label: 'Oldest', value: 'published_at'},
                {label: 'Duration', value: '-duration'},
            ],
            query: {
                category: null,
                page: null,
                sort: null,
                type: null,
                expertiseLevels: [],
                view: 'list',
                tags: [],
            },
            preserveScroll: true,
            viewMode: [
                {label: 'List Only', value: 'list'},
                {label: 'Including Icons', value: 'detail_view'},
            ],
            tagsKeywordList: [],
            search: '',
            openCategories: [],
        }
    },

    created() {
        this.query = _.merge(this.query, this.posts.constraints);
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        PostsList,
        SelectBox,
        CheckboxList,
        PaginationLinks
    },

    methods: {
        setPage(page) {
            this.preserveScroll = false;
            this.query = _.merge(this.query, {page});
        },
        updatePosts() {
            if(this.view == 'list') {
                this.queryParams.perPage = 30;
            }
            this.$inertia.visit(this.$inertia.page.url.split('?')[0], {
                method: 'get',
                data: this.queryParams,
                preserveState: true,
                preserveScroll: this.preserveScroll,
            });

            this.$nextTick(() => this.preserveScroll = true);
        },
        async fetchTagsList(type) {
            try {
                if(this.search) {
                    await axios.get(`/tags/list?search=${this.search}`).then(response => {
                        this.tagsKeywordList = response.data;
                    })
                } else if (type == 'paginate') {
                    await axios.get(`/tags/list?paginate=1`).then(response => {
                        this.tagsKeywordList = response.data.data;
                    })
                } else {
                     await axios.get(`/tags/list`).then(response => {
                        this.tagsKeywordList = response.data;
                    })
                }
                this.tagsKeywordList = this.tagsKeywordList.map(tag => {
                    if (this.query.tags.includes(tag.id)) {
                        return { ...tag, status: true };
                    }
                    return tag;
                });
            } catch (e) {
                console.error(e);
            }
        },
        toggleStatus(label) {
            label.status = !label.status;
            if (label.status) {
                this.query.tags.push(label.id);
            } else {
                this.query.tags = this.query.tags.filter(tags => tags !== label.id);
            }
            this.updatePosts();
        },
        clearSearch() {
            this.search = '';
            this.fetchTagsList('paginate');
        },
        toggleCategory(id) {
            if (this.openCategories.includes(id)) {
                this.openCategories = this.openCategories.filter(catId => catId !== id);
            } else {
                this.openCategories.push(id);
            }
        },
    },

    computed: {
        sort: {
            get() {
                return this.query.sort;
            },
            set(value) {
                this.query.sort = value;
                this.query.page = null;
            },
        },
        type: {
            get() {
                return this.query.type || null;
            },
            set(value) {
                this.query.type = value;
                this.query.page = null;
            }
        },
        levels: {
            get() {
                return this.query.expertiseLevels;
            },
            set(value) {
                this.query.expertiseLevels = value;
                this.query.page = null;
            },
        },
        subCategory: {
            get() {
                return this.query.category || null;
            },
            set(value) {
                this.query.category = value;
                this.query.page = null;
            },
        },
        subCategories() {
            return _.sortBy(this.category.children, '_lft').map(item => ({
                label: `${item.name} (${item.posts_count})`,
                value: item.id
            }));
        },
        queryParams() {
            return _.omitBy(this.query, value => _.isNil(value) || value === '' || (_.isArray(value) && _.isEmpty(value)))
        },
        breadcrumbQueryParams() {
            return _.omit(this.queryParams, 'category', 'page')
        },
        view: {
            get() {
                return this.query.view;
            },
            set(value) {
                this.query.view = value;
                this.query.page = null;
            }
        },
    },
    
     mounted(){
        this.fetchTagsList('paginate');
    },

    watch: {
        queryParams(query, old) {
            if (!_.isEmpty(old) && !_.isEqual(query, old)) {
                this.updatePosts();
            }
        },
    }
};

</script>
<style scoped>
    .display-filter{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
        max-width: 400px;
    }
    .show-more {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
        color: #3c5acf;
    }
    .search-keyword-modal {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .list-col {
        margin: 14px 0px 14px 0px;
    }
    .keyword-list-modal {
        max-width: 80%;
    }
    .search-button{
        margin-top: 36px;
    }
    .scroll-content {
        height: 430px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .anchor-color{
        color: #373737;
    }
</style>
